import { udApi, fetchCommonAppData } from '@udemy/ud-api';
import { getClientAppContext, isAppContextOnClientSupported } from './app-context';
export async function getNavData(params) {
  var _ref, _headerNavResponse$da;
  /*
      Mack and his team will eventually update the structure of this response.
      The children of the cat and subcat are SD Tags which will become generic tags.
  */
  const navList = params.isUFB ? 'ufb-main' : 'ud-main';
  const headerNavResponse = await udApi.get(`/structured-data/navigation-lists/?list_ids=${navList}&locale=${params.locale}`);

  // TODO: need to come back and rewire the mocks for unit tests
  // For now, write in a fallback to expediate a fix for FRON-487
  // return headerNavResponse.data[navList].items;
  const navListResponse = (_ref = (_headerNavResponse$da = headerNavResponse.data[navList]) !== null && _headerNavResponse$da !== void 0 ? _headerNavResponse$da : headerNavResponse.data['ufb-main']) !== null && _ref !== void 0 ? _ref : headerNavResponse.data['ud-main'];
  return navListResponse.items;
}
export async function loadCommonAppContext(locale, isUFB = false, cb) {
  if (isAppContextOnClientSupported()) {
    const commonAppDataResponse = await getClientAppContext();
    cb === null || cb === void 0 || cb(commonAppDataResponse);
    return commonAppDataResponse;
  } else {
    const [commonAppDataResponse, navigationCategories] = await Promise.all([fetchCommonAppData({
      header: true
    }), getNavData({
      locale,
      isUFB
    })]);
    commonAppDataResponse.data.header.navigationCategories = navigationCategories;
    cb === null || cb === void 0 || cb(commonAppDataResponse);
    return commonAppDataResponse;
  }
}
loadCommonAppContext.reset = () => {
  fetchCommonAppData.reset();
};
//# sourceMappingURL=load-common-app-context.js.map